"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorePayoutStatus = exports.CorePayinStatus = exports.CoreWalletTransactionReferenceType = exports.CoreWalletTransactionType = exports.CoreWalletType = exports.CorePaymentProviderStatus = exports.CoreProviderPayoutStatus = exports.CoreProviderPayinStatus = exports.CoreProviderWalletTransactionReferenceType = exports.CoreProviderWalletTransactionType = exports.CoreProviderWalletType = exports.CoreProviderPaymentListStatus = void 0;
// Shared canonical payment enums for APIs and frontends.
var CoreProviderPaymentListStatus;
(function (CoreProviderPaymentListStatus) {
    CoreProviderPaymentListStatus["ACTIVE"] = "ACTIVE";
    CoreProviderPaymentListStatus["DISABLED"] = "DISABLED";
    CoreProviderPaymentListStatus["DEPRECATED"] = "DEPRECATED";
})(CoreProviderPaymentListStatus || (exports.CoreProviderPaymentListStatus = CoreProviderPaymentListStatus = {}));
var CoreProviderWalletType;
(function (CoreProviderWalletType) {
    CoreProviderWalletType["ACTUAL"] = "ACTUAL";
    CoreProviderWalletType["ESCROW"] = "ESCROW";
    CoreProviderWalletType["FEE"] = "FEE";
})(CoreProviderWalletType || (exports.CoreProviderWalletType = CoreProviderWalletType = {}));
var CoreProviderWalletTransactionType;
(function (CoreProviderWalletTransactionType) {
    CoreProviderWalletTransactionType["CREDIT"] = "CREDIT";
    CoreProviderWalletTransactionType["DEBIT"] = "DEBIT";
})(CoreProviderWalletTransactionType || (exports.CoreProviderWalletTransactionType = CoreProviderWalletTransactionType = {}));
var CoreProviderWalletTransactionReferenceType;
(function (CoreProviderWalletTransactionReferenceType) {
    CoreProviderWalletTransactionReferenceType["PAYIN"] = "PAYIN";
    CoreProviderWalletTransactionReferenceType["PAYOUT"] = "PAYOUT";
    CoreProviderWalletTransactionReferenceType["FUND_TRANSFER"] = "FUND_TRANSFER";
    CoreProviderWalletTransactionReferenceType["ADJUSTMENT"] = "ADJUSTMENT";
})(CoreProviderWalletTransactionReferenceType || (exports.CoreProviderWalletTransactionReferenceType = CoreProviderWalletTransactionReferenceType = {}));
var CoreProviderPayinStatus;
(function (CoreProviderPayinStatus) {
    CoreProviderPayinStatus["INITIATED"] = "INITIATED";
    CoreProviderPayinStatus["PENDING"] = "PENDING";
    CoreProviderPayinStatus["PAID"] = "PAID";
    CoreProviderPayinStatus["FAILED"] = "FAILED";
    CoreProviderPayinStatus["REFUNDED"] = "REFUNDED";
})(CoreProviderPayinStatus || (exports.CoreProviderPayinStatus = CoreProviderPayinStatus = {}));
var CoreProviderPayoutStatus;
(function (CoreProviderPayoutStatus) {
    CoreProviderPayoutStatus["REQUESTED"] = "REQUESTED";
    CoreProviderPayoutStatus["PROCESSING"] = "PROCESSING";
    CoreProviderPayoutStatus["COMPLETED"] = "COMPLETED";
    CoreProviderPayoutStatus["FAILED"] = "FAILED";
})(CoreProviderPayoutStatus || (exports.CoreProviderPayoutStatus = CoreProviderPayoutStatus = {}));
// Backward-compatible aliases during migration.
exports.CorePaymentProviderStatus = CoreProviderPaymentListStatus;
exports.CoreWalletType = CoreProviderWalletType;
exports.CoreWalletTransactionType = CoreProviderWalletTransactionType;
exports.CoreWalletTransactionReferenceType = CoreProviderWalletTransactionReferenceType;
exports.CorePayinStatus = CoreProviderPayinStatus;
exports.CorePayoutStatus = CoreProviderPayoutStatus;
